import React from 'react';

const Info = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Simple Hero Bar */}
      <section className="bg-gradient-to-r from-green-600 to-blue-600 py-16">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
            Info Center
          </h1>
          <p className="text-xl md:text-2xl text-white opacity-90 max-w-3xl mx-auto">
            Learn how to use GEPredict platform
          </p>
        </div>
      </section>

      {/* YouTube Video Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              How to Use GEPredict
            </h2>
            <p className="text-lg text-gray-600">
              Watch our comprehensive tutorial video to learn how to use the GEPredict platform
            </p>
          </div>
          
          {/* YouTube Video Placeholder */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="aspect-video bg-gray-200 flex items-center justify-center">
              <div className="text-center">
                <div className="text-6xl mb-4">📹</div>
                <p className="text-xl text-gray-600 mb-2">YouTube Video Tutorial</p>
                <p className="text-gray-500">Replace this placeholder with your YouTube video embed code</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Info;
